function formatDisplayBps(bps: number): number {
  return Math.floor(bps)
}

export { formatDisplayBps }
